import { connect } from "react-redux";
import AccountHome from "./AccountHome.js";
import { getisSpecialtyPortalView } from "../../portalview/changePortalViewStateSelectors";

const mapStateToProps = state => ({
  isSpecialtyPortalView: getisSpecialtyPortalView(state)
});

export default connect(mapStateToProps)(AccountHome);
